"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4222],{

/***/ 32622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ selectable_tag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./static/svg/check.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCheck = function SvgCheck(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 7,
        viewBox: "0 0 10 7"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        d: "M1.22 3.005a.725.725 0 0 0-1.01 0 .69.69 0 0 0 0 .99l2.856 2.8a.725.725 0 0 0 1.01 0l5.715-5.6a.69.69 0 0 0 0-.99.725.725 0 0 0-1.01 0L3.57 5.31z"
    })));
};
/* harmony default export */ var check = (SvgCheck);

// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag-constants.js
var MAIN_CLASSNAME = "selectable-tag-wrapper"; // used in the scss file but can't inject it so mind if changing

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/default-props.js
/* harmony default export */ var default_props = ({
    tagText: "Project Management",
    isSelected: false,
    tagBackgroundColor: "auto",
    tagValue: null,
    overridePageCluster: null,
    overridePageSubCluster: null,
    galleryImage: null
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.scss.js




var tagSelectedBackgroundColor = "#dff0ff";
var tagSelectedBackgroundColorDarkMode = "#49497D";
var VISIBLE_CHECKMARK_STYLE = "\n      background-color: currentColor;\n      box-shadow: inset 0px 0px 0px 1.5px currentColor;\n      border: none;\n";
var StyledSelectableTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej25d0q0"
})("padding:4px 16px 4px 4px;border-radius:80px;display:flex;flex-direction:row;justify-content:center;align-items:center;cursor:pointer;margin:6px 12px 6px 0;background:", colors/* default.riverstone */.Z.riverstone, ";&.dark-mode{background:", colors/* default.midnightblue */.Z.midnightblue, ";&.selected{background-color:", tagSelectedBackgroundColorDarkMode, ";&:hover{background-color:", tagSelectedBackgroundColorDarkMode, ";}}&.square .selectable-tag-image-container{background:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.mobile-clusters{margin-right:6px;background:white;padding:4px 12px 5px 4px;&:hover{background:white;}.tag-text{font-size:0.844rem;}}}&.square{padding:8px 16px 8px 12px;.selectable-tag-image-container{border-radius:2px;width:18px;height:18px;background-color:", colors/* default.white */.Z.white, ";box-shadow:none;border:1px solid currentColor;}.tag-text{font-size:0.875rem;}&.selected{.selectable-tag-image-container{", VISIBLE_CHECKMARK_STYLE, "}}}&:hover{background:", colors/* default.border-gray */.Z["border-gray"], ";outline:0;&.dark-mode{background:", colors/* default.midnightblue-hover */.Z["midnightblue-hover"], ";}}.selectable-tag-image-container{width:32px;height:32px;border-radius:50%;display:flex;justify-content:center;align-items:center;user-select:none;.selectable-tag-image{display:flex;justify-content:center;align-items:center;height:100%;img{width:16px;height:16px;}}}.tag-text{margin-left:8px;font-size:0.8125rem;line-height:22px;}&.selected{background-color:", tagSelectedBackgroundColor, ";&:hover{background-color:", tagSelectedBackgroundColor, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.js











var SelectableTag = function(props) {
    var tagText = props.tagText, showMobileClusterTags = props.showMobileClusterTags, darkMode = props.darkMode, onHover = props.onHover, value = props.value, galleryImage = props.galleryImage, tagBackgroundColor = props.tagBackgroundColor, overridePageCluster = props.overridePageCluster, isSelected = props.isSelected;
    var ref = (0,react.useState)(false), isSelectedState = ref[0], setIsSelected = ref[1];
    (0,react.useEffect)(function() {
        setIsSelected(isSelected);
    }, [
        isSelected
    ]);
    var blurTag = function(e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(MAIN_CLASSNAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    var onMouseOver = function() {
        var tag = {
            isSelectedState: isSelectedState,
            tagText: tagText,
            value: value,
            galleryImage: galleryImage
        };
        onHover && onHover(tag);
    };
    var onClick = function(e) {
        blurTag(e);
        toggleTagSelection();
    };
    var toggleTagSelection = function() {
        var nextSelectedState = !isSelectedState;
        setIsSelected(nextSelectedState);
        props.onClick && props.onClick(nextSelectedState);
        BigBrain("track", bigbrain_event_types.SELECTED_TAG_EVENT, {
            kind: nextSelectedState,
            info1: tagText,
            info2: tagBackgroundColor
        });
    };
    var getTagContainerStyle = function() {
        if (showMobileClusterTags) {
            return {
                border: "1px solid ".concat(colors/* default */.Z[tagBackgroundColor])
            };
        }
        return {};
    };
    var getTagImageContainerStyle = function() {
        return {
            color: colors/* default */.Z[tagBackgroundColor]
        };
    };
    var getCheckIconImageStyle = function() {
        var fill = darkMode ? colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME] : colors/* default.white */.Z.white;
        return {
            fill: fill
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableTag, {
        role: "button",
        className: classnames_default()(MAIN_CLASSNAME, {
            selected: isSelectedState,
            "dark-mode": darkMode,
            square: !showMobileClusterTags,
            "mobile-clusters": showMobileClusterTags
        }),
        style: getTagContainerStyle(),
        onClick: onClick,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(toggleTagSelection),
        tabIndex: 0,
        onMouseEnter: onMouseOver,
        onFocus: onMouseOver,
        children: [
            !showMobileClusterTags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selectable-tag-image-container",
                style: getTagImageContainerStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {
                    className: "selectable-tag-image",
                    style: getCheckIconImageStyle()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tag-text",
                children: tagText
            })
        ]
    });
};
SelectableTag.defaultProps = default_props;
/* harmony default export */ var selectable_tag = (SelectableTag);


/***/ }),

/***/ 24263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75650);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(273);



/* harmony default export */ __webpack_exports__["Z"] = ({
    width: "100%",
    gridSelectableTags: [
        {
            tagText: "Creative & design",
            tagBackgroundColor: "lipstick",
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.DESIGN_AND_CREATIVE
        },
        {
            tagText: "Sales & CRM",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.CRM_PRIMARY_COLOR,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.CRM
        },
        {
            tagText: "Project management",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.PROJECTS_PRIMARY_COLOR,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.GENERIC_CLUSTER,
            overridePageSubCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.PROJECT_MANAGEMENT_USE_CASE
        },
        {
            tagText: "Marketing",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.MARKETER_PRIMARY_COLOR,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.MARKETING
        },
        {
            tagText: "HR",
            tagBackgroundColor: "sunset",
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.HR
        },
        {
            tagText: "Task management",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.GENERIC_CLUSTER
        },
        {
            tagText: "Software development",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.DEV_PRIMARY_COLOR,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.SOFTWARE
        },
        {
            tagText: "Operations",
            tagBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.BRAND_PRIMARY_YELLOW,
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.OPERATIONS
        },
        {
            tagText: "More workflows",
            tagBackgroundColor: "chill-blue",
            overridePageCluster: constants_clusters__WEBPACK_IMPORTED_MODULE_1__.GENERIC_CLUSTER
        }
    ],
    buttonConfig: {
        buttonType: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__/* .SIGNUP_BUTTON_TYPE */ .ge,
        additionalText: "No credit card needed &nbsp • &nbsp Unlimited time on Free plan"
    },
    withSecondaryButton: false,
    secondaryButtonConfig: null,
    buttonTopMargin: "44px"
});


/***/ }),

/***/ 76445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ selectable_tags_grid_button_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/animated-tag/animated-tag-constants.js
var MAX_TAG_WIDTH = "20";
var MAX_TAG_HEIGHT = "20";

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/animated-tag/animated-tag-component.scss.js


var StyledAnimatedTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej5729b0"
})("display:flex;justify-content:center;align-items:center;width:", MAX_TAG_WIDTH, "px;height:", MAX_TAG_HEIGHT, "px;border-radius:50%;position:absolute;animation:tagAnimation 0.5s 1;&.square{border-radius:2px;}@keyframes tagAnimation{0%{transform:translateY(0) rotate(24deg) scale(0.2);animation-timing-function:linear;}25%{transform:translateY(-18px) rotate(24deg) scale(1);animation-timing-function:ease-out;}50%{transform:translateY(-36px) rotate(24deg) scale(1);animation-timing-function:ease-in;}100%{transform:translateY(0px) rotate(0) scale(1);animation-timing-function:linear;}}.picture-component{display:flex;justify-content:center;align-items:center;user-select:none;width:100%;height:100%;img{width:50%;height:50%;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/animated-tag/animated-tag-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var AnimatedTag = function(props) {
    var tagToAnimate = props.tagToAnimate, tagStartingPosition = props.tagStartingPosition, onAnimationEndCallback = props.onAnimationEndCallback;
    var tagImg = tagToAnimate.tagImg, tagBackgroundColor = tagToAnimate.tagBackgroundColor, tagIndex = tagToAnimate.tagIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedTag, {
        className: classnames_default()("animated-tag", "square"),
        style: _object_spread({
            backgroundColor: colors/* default */.Z[tagBackgroundColor]
        }, tagStartingPosition),
        onAnimationEnd: function() {
            return onAnimationEndCallback(tagIndex);
        }
    });
};
/* harmony default export */ var animated_tag_component = (AnimatedTag);

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/selectable-tags-grid-button-component.scss.js


var StyledSelectableTagsGridButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1gh8fec0"
})("width:100%;display:flex;justify-content:center;align-items:flex-start;gap:24px;.secondary-button-wrapper,.youtube-button-wrapper{height:50px;display:flex;align-items:center;}.button-wrapper{&.shake-button{animation:shakeAnimation 0.5s 1;animation-timing-function:ease-in-out;}@keyframes shakeAnimation{0%{transform:scale(1);}15%{transform:scale(1.05);}35%{transform:scale(0.989);}67.5%{transform:scale(1.005);}100%{transform:scale(1);}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:column;align-items:center;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js + 3 modules
var youtube_popup_button = __webpack_require__(25101);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/selectable-tags-grid-button-component.js

function selectable_tags_grid_button_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_grid_button_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_grid_button_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var SelectableTagsGridButtonComponent = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var buttonConfig = props.buttonConfig, beforeRedirectSyncAction = props.beforeRedirectSyncAction, secondaryButtonConfig = props.secondaryButtonConfig, youTubeButtonConfig = props.youTubeButtonConfig, skipSignupUpdateCluster = props.skipSignupUpdateCluster, shouldSendClustersAsParams = props.shouldSendClustersAsParams, displayedOnDarkTheme = props.displayedOnDarkTheme, style = props.style, websiteAlignmentBranding = props.websiteAlignmentBranding, disableAnimation = props.disableAnimation;
    var _$ref = (0,react.useState)([]), animatedTags = _$ref[0], setAnimatedTags = _$ref[1];
    var _$ref1 = (0,react.useState)({}), tagStartingPosition = _$ref1[0], setTagStartingPosition = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), shakeButton = _$ref2[0], setShakeButton = _$ref2[1];
    var _$ref3 = (0,react.useState)(null), paintButtonColor = _$ref3[0], setPaintButtonColor = _$ref3[1];
    var buttonContainerRef = (0,react.useRef)();
    var updateStartingPosition = function() {
        requestAnimationFrame(function() {
            var _buttonContainerRef_current;
            //  we want to put it in the center of the button, it's dynamic width so need to calculate it
            var buttonToCalculateFor = (_buttonContainerRef_current = buttonContainerRef.current) === null || _buttonContainerRef_current === void 0 ? void 0 : _buttonContainerRef_current.querySelector("button");
            if (!buttonToCalculateFor) return;
            var boundClientRect = buttonToCalculateFor.getBoundingClientRect();
            var startingPositionFromLeft = boundClientRect.left + (boundClientRect.width / 2 - MAX_TAG_WIDTH / 2);
            setTagStartingPosition({
                left: startingPositionFromLeft
            });
        });
    };
    var onTagAnimationEndCallback = (0,react.useCallback)(function(tagIndex) {
        var filtered = animatedTags.filter(function(t) {
            return t.tagIndex !== tagIndex;
        });
        setAnimatedTags((0,_to_consumable_array/* default */.Z)(filtered));
        if (disableAnimation) return;
        if (shakeButton) {
            setShakeButton(false);
            setTimeout(function() {
                setShakeButton(true);
            }, 0);
        } else {
            setShakeButton(true);
        }
    }, [
        disableAnimation,
        shakeButton
    ]);
    var renderSelectionAnimationIfNeeded = function() {
        if (!(tagStartingPosition === null || tagStartingPosition === void 0 ? void 0 : tagStartingPosition.left)) return null;
        return animatedTags.map(function(tagToAnimate) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(animated_tag_component, {
                tagToAnimate: tagToAnimate,
                tagStartingPosition: tagStartingPosition,
                onAnimationEndCallback: onTagAnimationEndCallback
            }, tagToAnimate.tagIndex);
        });
    };
    (0,react.useEffect)(function() {
        if (!websiteAlignmentBranding) {
            updateStartingPosition();
            window.addEventListener("resize", updateStartingPosition, {
                passive: true
            });
            return function() {
                window.removeEventListener("resize", updateStartingPosition, {
                    passive: true
                });
            };
        }
    }, []);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            clickedTag: function(gridSelectableTag, isSelected) {
                if (!isSelected) return;
                if (websiteAlignmentBranding) {
                    setPaintButtonColor(gridSelectableTag.tagBackgroundColor);
                    !disableAnimation && setShakeButton(true);
                } else {
                    //  adding new and removing current if already there
                    setAnimatedTags([
                        gridSelectableTag
                    ].concat((0,_to_consumable_array/* default */.Z)(animatedTags.filter(function(t) {
                        return t.tagIndex !== gridSelectableTag.tagIndex;
                    }))));
                }
            }
        };
    }, [
        animatedTags,
        disableAnimation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableTagsGridButtonComponent, {
        className: "selectable-tags-button-container",
        ref: buttonContainerRef,
        style: style,
        children: [
            !websiteAlignmentBranding && renderSelectionAnimationIfNeeded(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("button-wrapper", {
                    "shake-button": shakeButton
                }),
                onAnimationEnd: function() {
                    return !disableAnimation && shakeButton && setShakeButton(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(selectable_tags_grid_button_component_object_spread({}, buttonConfig), {
                    shouldSendClustersAsParams: shouldSendClustersAsParams,
                    beforeSubmitCallback: beforeRedirectSyncAction,
                    skipUpdateCluster: skipSignupUpdateCluster,
                    displayedOnDarkTheme: displayedOnDarkTheme,
                    paintButtonColor: paintButtonColor
                }))
            }),
            secondaryButtonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "secondary-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, selectable_tags_grid_button_component_object_spread({}, secondaryButtonConfig))
            }),
            youTubeButtonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "youtube-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_popup_button/* default */.Z, selectable_tags_grid_button_component_object_spread({}, youTubeButtonConfig))
            })
        ]
    });
});
/* harmony default export */ var selectable_tags_grid_button_component = (SelectableTagsGridButtonComponent);


/***/ }),

/***/ 94222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ selectable_tags_grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.js + 4 modules
var selectable_tag = __webpack_require__(32622);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid-button-component/selectable-tags-grid-button-component.js + 4 modules
var selectable_tags_grid_button_component = __webpack_require__(76445);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid.scss.js


var MOBILE_SELECTABLE_CONTAINER_HEIGHT_PX = "47px";
var StyledSelectableTagsGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emir9wx0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;display:flex;flex-direction:column;align-items:center;.selectable-tags-container-wrapper{display:flex;flex-wrap:wrap;justify-content:center;.selectable-tags-wrapper{flex-wrap:wrap;justify-content:center;margin:auto;}}.selectable-tags-button-container{margin-top:32px;}&.left{align-items:flex-start;.selectable-tags-container-wrapper{justify-content:flex-start;}.selectable-tags-button-container{width:unset;}}&.center{align-items:center;.selectable-tags-container-wrapper{justify-content:center;}.selectable-tags-button-container{width:unset;}}&.right{align-items:flex-end;.selectable-tags-container-wrapper{justify-content:flex-end;}.selectable-tags-button-container{width:unset;}}&.mobile{padding:0;max-width:100%;box-sizing:border-box;.selectable-tags-container-wrapper{display:unset;overflow-x:scroll;overflow-y:hidden;white-space:nowrap;max-width:100%;scroll-snap-type:x mandatory;.grid-selectable-group-container{display:inline-flex;flex-direction:column;margin:0 5vw;scroll-snap-align:center;.grid-selectable-container{max-width:350px;width:60vw;.selectable-tag-image-container{flex-shrink:0;}.tag-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;}}&:last-of-type{margin-right:25vw;}}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){padding:0px 16px;max-width:100%;box-sizing:border-box;.grid-selectable-container{flex:1;flex-shrink:0;flex-basis:33%;.selectable-tag-image-container{flex-shrink:0;}.tag-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;}}&.mobile-clusters{.selectable-tags-container-wrapper{.grid-selectable-container{flex-grow:0;flex-basis:auto;height:", MOBILE_SELECTABLE_CONTAINER_HEIGHT_PX, ";}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/default-props.js
var default_props = __webpack_require__(24263);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/square-tags.js + 4 modules
var square_tags = __webpack_require__(76416);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var SelectableTagsGrid = function(props) {
    var ref = (0,react.useState)([]), selectedTags = ref[0], setSelectedTags = ref[1];
    var buttonContainer = (0,react.useRef)(null);
    var onTagToggle = props.onTagToggle, darkMode = props.darkMode, gridSelectableTags = props.gridSelectableTags, clusterId = props.clusterId, clusterVariant = props.clusterVariant, useMobileClusterTags = props.useMobileClusterTags, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, sendClustersAsParams = props.sendClustersAsParams, buttonConfig = props.buttonConfig, align = props.align, secondaryButtonConfig = props.secondaryButtonConfig, youTubeButtonConfig = props.youTubeButtonConfig, withSecondaryButton = props.withSecondaryButton, withYouTubeButton = props.withYouTubeButton, width = props.width, theme = props.theme, buttonTopMargin = props.buttonTopMargin, websiteAlignmentBranding = props.websiteAlignmentBranding, disableAnimation = props.disableAnimation, IsInCrmUseCasesTest = props.IsInCrmUseCasesTest;
    var getSelectedTagFromUrl = function() {
        var selectedTagId = (0,url.getUrlParamValueFromCurrentLocation)(square_tags/* PRESELECTED_TAG_PARAM_NAME */.x);
        if (!selectedTagId) return;
        return gridSelectableTags.find(function(cluster) {
            return cluster.overridePageCluster === selectedTagId || cluster.overridePageSubCluster === selectedTagId;
        });
    };
    (0,react.useEffect)(function() {
        // pre-select tags that were marked with 'Initially Selected' or taken from URL
        setSelectedTags(gridSelectableTags.filter(function(tag) {
            return tag.initiallySelected || tag === getSelectedTagFromUrl();
        }));
        //  Cookie used for CRM use cases ab test only - will be removed after test.
        (0,cookies_service/* setCookie */.d8)(cookies.IS_IN_CRM_USE_CASES_TEST_VARIANT, IsInCrmUseCasesTest, {
            expires: 1 // 1 day
        });
    }, []);
    var onSelectableTagClick = function(gridSelectableTag, index, isSelected) {
        var _buttonContainer_current;
        (_buttonContainer_current = buttonContainer.current) === null || _buttonContainer_current === void 0 ? void 0 : _buttonContainer_current.clickedTag(_object_spread({
            tagIndex: index
        }, gridSelectableTag), isSelected);
        var newSelectedTags = isSelected ? (0,_to_consumable_array/* default */.Z)(selectedTags).concat([
            _object_spread_props(_object_spread({}, gridSelectableTag), {
                index: index
            })
        ]) : selectedTags.filter(function(s) {
            return s.index !== index;
        });
        setSelectedTags(newSelectedTags);
        onTagToggle && onTagToggle(newSelectedTags);
    };
    var renderSelectableTags = function(gridTag, index) {
        var showMobileClusterTags = shouldShowMobileClusterTags();
        var gridSelectableTag = _object_spread_props(_object_spread({}, gridTag), {
            isSelected: selectedTags.find(function(tag) {
                return gridTag.tagText === tag.tagText;
            }) !== undefined
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("grid-selectable-container", {
                "no-select": showMobileClusterTags
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tag/* default */.Z, _object_spread_props(_object_spread({}, gridSelectableTag), {
                onClick: function(isSelected) {
                    return onSelectableTagClick(gridSelectableTag, index, isSelected);
                },
                showMobileClusterTags: showMobileClusterTags,
                darkMode: darkMode
            }))
        }, index);
    };
    var renderSelectableTagsGrid = function() {
        return gridSelectableTags.map(renderSelectableTags);
    };
    var updateClustersBeforeSignup = function() {
        var extraParams = {};
        var clustersToUpdate = selectedTags.map(function(cluster) {
            var tagValue = cluster.tagValue, clusterFromTag = cluster.overridePageCluster, useCaseFromTag = cluster.overridePageSubCluster;
            var useCaseId = useCaseFromTag || tagValue; // tagValue is for old prop support
            var res = [];
            if (clusterFromTag) {
                res.push({
                    clusterId: clusterFromTag,
                    clusterType: types.CLUSTER_TYPE
                });
            }
            if (useCaseId) {
                var clusterIdToUse = clusterFromTag || clusterId;
                var extraData = clusterIdToUse ? {
                    parent_cluster_id: clusterIdToUse
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        if (clustersToUpdate.length === 0 && clusterId) {
            clustersToUpdate.push({
                clusterId: clusterId,
                clusterType: types.CLUSTER_TYPE
            }); // if not tags selected use the page cluster
        }
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, clusters.HP_TAGS_SELECTION);
            // This is temporarily here because we concat it to the url
            var clusterIds = (0,_to_consumable_array/* default */.Z)(new Set(flattenedArray.map(function(c) {
                return c.clusterId;
            }).filter(function(c) {
                return c !== clusters.GENERIC_CLUSTER;
            })));
            extraParams = {
                clusterIds: clusterIds
            };
        }
        return {
            params: _object_spread_props(_object_spread({}, extraParams), {
                clusterVariant: clusterVariant
            })
        };
    };
    var shouldShowMobileClusterTags = function() {
        return isMobileOrTabletBrowser && useMobileClusterTags;
    };
    var shouldSendClustersAsParams = function() {
        return shouldShowMobileClusterTags() && sendClustersAsParams;
    };
    var showMobileClusterTags = shouldShowMobileClusterTags();
    var displayedOnDarkTheme = (0,segments_service/* isDarkTheme */.$o)(theme);
    var selectableTagsGridButtonInlineStyle = {
        marginTop: buttonTopMargin
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableTagsGrid, {
        className: classnames_default()("selectable-tags-grid", align, {
            "mobile-clusters": showMobileClusterTags
        }),
        style: {
            width: showMobileClusterTags ? "100%" : width
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selectable-tags-container-wrapper",
                children: renderSelectableTagsGrid()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tags_grid_button_component/* default */.Z, {
                ref: buttonContainer,
                disableAnimation: disableAnimation,
                buttonConfig: _object_spread_props(_object_spread({}, buttonConfig), {
                    forceInputHide: true
                }),
                beforeRedirectSyncAction: updateClustersBeforeSignup,
                secondaryButtonConfig: withSecondaryButton && secondaryButtonConfig,
                youTubeButtonConfig: withYouTubeButton && youTubeButtonConfig,
                skipSignupUpdateCluster: true,
                shouldSendClustersAsParams: shouldSendClustersAsParams(),
                displayedOnDarkTheme: displayedOnDarkTheme,
                style: selectableTagsGridButtonInlineStyle,
                websiteAlignmentBranding: websiteAlignmentBranding
            })
        ]
    });
};
/* harmony default export */ var selectable_tags_grid = ((0,generic_config_context/* withGenericConfig */.P)(SelectableTagsGrid));
SelectableTagsGrid.defaultProps = default_props/* default */.Z;


/***/ })

}]);